import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { NotificationService } from "src/app/notifications/notification.service";
import { UiService } from "src/app/ui/ui.service";
import { AuthService } from "../auth.service";

@Component({
  selector: "app-forgot-password",
  templateUrl: "./forgot-password.component.html",
  styleUrls: ["./forgot-password.component.scss"],
})
export class ForgotPasswordComponent implements OnInit {
  forgotPasswordForm = new FormGroup({
    email: new FormControl("", [Validators.required, Validators.email]),
  });
  emailSent = false;
  private onComponentDestroy = new Subject();

  constructor(
    private AuthService: AuthService,
    private NotificationService: NotificationService,
    private uiService: UiService,
  ) {}

  ngOnInit(): void {}

  ngOnDestroy() {
    this.onComponentDestroy.next();
    this.onComponentDestroy.complete();
  }

  submitForgotPassword() {
    this.uiService
      .waitForEvent(
        this.AuthService.requestResetPassword(
          this.forgotPasswordForm.controls.email.value,
        ),
      )
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe(
        () => {
          this.NotificationService.openSuccessSnackBar(
            "Password reset email sent",
          );
          this.emailSent = true;
        },
        (err) => {
          this.NotificationService.openErrorSnackBar(
            err?.error?.message ?? "Error sending reset email",
          );
        },
      );
  }
}
